(function (SocialShare, $, undefined) {
  
  var injectPinterestScript = function () {
    var d = document;
    var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
    p.type = 'text/javascript';
    p.async = true;
    p.src = '//assets.pinterest.com/js/pinit.js';
    f.parentNode.insertBefore(p, f);
  };

  var bindUIActions = function () {
    $(document).on('click', '.social-link', function (event) {
      event.preventDefault();
      switch ($(this).data('network')) {
        case 'facebook':
          // console.log('facebook');
          window.open('http://www.facebook.com/sharer/sharer.php?u=' + window.location.href, 'Facebook', 'width=600, height=400, scrollbars=no');
          break;
        case 'twitter':
          window.open('http://www.twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href), 'Tweet', 'width=600, height=400, scrollbars=no');
          break;
        case 'pinterest':
          var url = encodeURIComponent(window.location.href);
          var imgURL = encodeURIComponent($('.image-main img').attr('src'));
          var description = $('.product-description').text();
          if($('body').hasClass('template-article')){
            imgURL = encodeURIComponent($('.post-hero img').attr('src'));
            description = $('.post-title').text();
          }
          window.open('http://pinterest.com/pin/create/button/?url=' + url + '&media=' + imgURL + '&description=' + description, 'Pinterest', 'width=600, height=400, scrollbars=no');
          break;
        case 'google-plus':
          window.open('https://plus.google.com/share?url=' + encodeURIComponent(window.location.href), 'GooglePlus', 'width=680, height=450, scrollbars=no');
          break;
        case 'email':
          var emailTo = '';
          var emailCC = '';
          var emailSub = $('.product_title').text();
          var url = encodeURIComponent(window.location.href);
          location.href= "mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+ url;
      }
    });
  };

  // Public / Init
  SocialShare.init = function () {
    bindUIActions();
    injectPinterestScript();
  };

}(window.SocialShare = window.SocialShare || {}, jQuery));
